module.exports = __webpack_public_path__ + "img/tu2.5dbe3f99.png";